<template lang="pug">
b-modal#editSEOPage(
  ref="editSEOPage"
  :title="$t('ui.combine.edit_seo_page')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row
      div.col-sm-12.col-md-12.col-lg-12
        b-form-group(:label="$t('ui.page_name')" disabled).mb-0
          SEOPageNameLookup(
            ref="page_name"
            size="sm"
            required
            :dirty="$v.page_name.$dirty"
            :error="$v.page_name.$error"
            v-model.trim.lazy="$v.page_name.$model"
            :disabled="loading"
            :operatorID="operatorID"
          )
          ValidateResult(:value="$v.page_name" :name="$t('ui.page_name')")
          //- DebounceInput(
          //-   size="sm"
          //-   ref="page_name"
          //-   type="text"
          //-   :dirty="$v.page_name.$dirty"
          //-   :error="$v.page_name.$error"
          //-   v-model.trim.lazy="$v.page_name.$model"
          //-   :disabled="loading"
          //- )
          //- ValidateResult(:value="$v.page_name" :name="$t('ui.page_name')")
    .row
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.meta_title')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_title"
            type="text"
            :dirty="$v.meta_title.$dirty"
            :error="$v.meta_title.$error"
            v-model.trim.lazy="$v.meta_title.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_title" :name="$t('ui.meta_title')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.meta_keywords')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_keywords"
            type="text"
            :dirty="$v.meta_keywords.$dirty"
            :error="$v.meta_keywords.$error"
            v-model.trim.lazy="$v.meta_keywords.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_keywords" :name="$t('ui.meta_keywords')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.meta_url')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_url"
            type="text"
            :dirty="$v.meta_url.$dirty"
            :error="$v.meta_url.$error"
            v-model.trim.lazy="$v.meta_url.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_url" :name="$t('ui.meta_url')")
    .row
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.meta_canonical')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_canonical"
            type="text"
            :dirty="$v.meta_canonical.$dirty"
            :error="$v.meta_canonical.$error"
            v-model.trim.lazy="$v.meta_canonical.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_canonical" :name="$t('ui.meta_canonical')")
        b-form-group(:label="$t('ui.meta_lang')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_lang"
            type="text"
            :dirty="$v.meta_lang.$dirty"
            :error="$v.meta_lang.$error"
            v-model.trim.lazy="$v.meta_lang.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_lang" :name="$t('ui.meta_lang')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.meta_author')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_author"
            type="text"
            :dirty="$v.meta_author.$dirty"
            :error="$v.meta_author.$error"
            v-model.trim.lazy="$v.meta_author.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_author" :name="$t('ui.meta_author')")
        b-form-group(:label="$t('ui.meta_publisher')").mb-0
          DebounceInput(
            size="sm"
            ref="meta_publisher"
            type="text"
            :dirty="$v.meta_publisher.$dirty"
            :error="$v.meta_publisher.$error"
            v-model.trim.lazy="$v.meta_publisher.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.meta_publisher" :name="$t('ui.meta_publisher')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.meta_desc')")
          b-form-textarea(
            ref="meta_desc"
            :dirty="$v.meta_desc.$dirty"
            :error="$v.meta_desc.$error"
            v-model.trim.lazy="$v.meta_desc.$model"
            style="height:97px;"
          )
          ValidateResult(:value="$v.meta_desc" :name="$t('ui.meta_desc')")
    .row
      div.col-sm-12.col-md-12.col-lg-12
        //- b-form-group.w-100(:label="$t('ui.meta_image_url')").mb-0
        //-   DebounceInput(
        //-     size="sm"
        //-     ref="meta_image_url"
        //-     type="text"
        //-     :dirty="$v.meta_image_url.$dirty"
        //-     :error="$v.meta_image_url.$error"
        //-     v-model.trim.lazy="$v.meta_image_url.$model"
        //-     :disabled="loading"
        //-   )
        //-   ValidateResult(:value="$v.meta_image_url" :name="$t('ui.meta_image_url')")
        .alert.alert-warning.p-1.mb-2.w-100 *{{ $t("message.banner_size_tooltips", { size: "200px * 200px" }) }}
        b-form-group.w-100(:label="$t('ui.meta_image')").mb-0
          b-form-file(
            :dirty="$v.meta_image.$dirty"
            :error="$v.meta_image.$error"
            v-model.trim.lazy="$v.meta_image.$model"
            ref="file"
            accept="image/jpeg, image/png, image/jpg"
            @change="onSelectMeta"
            v-if="metaImageSrc == null"
          )
          small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
          ValidateResult(:value="$v.meta_image" :name="$t('ui.meta_image')")
          SubmitButton(
            :loading="loading"
            icon="fa fa-times"
            :text="$t('ui.remove')"
            type="button"
            @click="removeMetaImage()"
            variant="danger"
            size="sm"
            v-if="metaImageSrc != null"
            )
          br
          b-img.w-50.h-50.mb-2(v-if="metaImageSrc != null" :src="metaImageSrc")
    .row.mb-2(style="margin-top:-13px;")
      .col-12
        b-form-group(:label="$t('ui.schema')")
          b-form-textarea(
            ref="schema"
            v-model="schema"
            style="height:97px;"
          )
    .row
      .col-12
        ul#editorTab.nav.nav-tabs(role='tablist')
          li.nav-item
            a#en-tab.nav-link(data-toggle='tab' href='#en-content' role='tab' aria-controls='en' aria-selected='false' @click="setTab('en')" :class="activeTab == 'en' ? 'active' : ''") {{ $t("ui.en") }}
          li.nav-item
            a#cn-tab.nav-link(data-toggle='tab' href='#cn-content' role='tab' aria-controls='cn' aria-selected='false' @click="setTab('cn')" :class="activeTab == 'cn' ? 'active' : ''") {{ $t("ui.cn") }}
          li.nav-item
            a#local-tab.nav-link(data-toggle='tab' href='#local-content' role='tab' aria-controls='local' aria-selected='false' @click="setTab('local')" :class="activeTab == 'local' ? 'active' : ''") {{ $t("ui.local") }}

        #editorcontent.tab-content.tab-bordered
          #en-content.tab-pane(:class="activeTab == 'en' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='en-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.item')").mb-0
                DebounceInput(
                  size="sm"
                  ref="en_item_name"
                  type="text"
                  :dirty="$v.en_item_name.$dirty"
                  :error="$v.en_item_name.$error"
                  v-model.trim.lazy="$v.en_item_name.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.en_item_name" :name="$t('ui.item')")
              b-form-group.w-100(:label="$t('ui.body')").mb-0
                ckeditor(
                  v-model="en_body"
                  :disabled="loading"
                  :config="enBodyConfig"
                )

          #cn-content.tab-pane(:class="activeTab == 'cn' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='cn-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.item')").mb-0
                DebounceInput(
                  size="sm"
                  ref="cn_item_name"
                  type="text"
                  :dirty="$v.cn_item_name.$dirty"
                  :error="$v.cn_item_name.$error"
                  v-model.trim.lazy="$v.cn_item_name.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.cn_item_name" :name="$t('ui.item')")
              b-form-group.w-100(:label="$t('ui.body')").mb-0
                ckeditor(
                  v-model="cn_body"
                  :disabled="loading"
                  :config="cnBodyConfig"
                )

          #local-content.tab-pane(:class="activeTab == 'local' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='local-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.item')").mb-0
                DebounceInput(
                  size="sm"
                  ref="local_item_name"
                  type="text"
                  :dirty="$v.local_item_name.$dirty"
                  :error="$v.local_item_name.$error"
                  v-model.trim.lazy="$v.local_item_name.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.local_item_name" :name="$t('ui.item')")
              b-form-group.w-100(:label="$t('ui.body')").mb-0
                ckeditor(
                  v-model="local_body"
                  :disabled="loading"
                  :config="localBodyConfig"
                )

    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import SEOPageNameLookup from "@/library/SEOPageNameLookup";
import { VueEditor, Quill } from "vue2-editor";
import $ from 'jquery';
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor,
    SEOPageNameLookup
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      meta_title: "",
      meta_desc: "",
      meta_keywords: "",
      meta_url: "",
      meta_canonical: "",
      meta_author: "",
      meta_publisher: "",
      meta_lang: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      page_name: "",
      en_item_name: "",
      en_body: "",
      cn_item_name: "",
      cn_body: "",
      local_item_name: "",
      local_body: "",
      localBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.localBodyEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      enBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.enBodyEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      cnBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.cnBodyEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      file: "",
      meta_image_url: "",
      meta_image: null,
      metaImageName: "",
      metaImageSrc: null,
      page_id: 0,
      activeTab: "en",
      imagePath: config.viewImageUrl,
      schema: "",
      enBodyEditorInstance: null,
      cnBodyEditorInstance: null,
      localBodyEditorInstance: null
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    page_name: {
      required
    },
    en_item_name: {
      maxLength: maxLength(255)
    },
    cn_item_name: {
      maxLength: maxLength(255)
    },
    local_item_name: {
      maxLength: maxLength(255)
    },
    meta_title: {
      maxLength: maxLength(255)
    },
    meta_desc: {
      maxLength: maxLength(500)
    },
    meta_keywords: {
      maxLength: maxLength(500)
    },
    meta_url: {
      maxLength: maxLength(500)
    },
    meta_canonical: {
      maxLength: maxLength(500)
    },
    meta_author: {
      maxLength: maxLength(255)
    },
    meta_publisher: {
      maxLength: maxLength(255)
    },
    meta_lang: {
      maxLength: maxLength(10)
    },
    // meta_image_url: {
    //   maxLength: maxLength(500)
    // },
    meta_image: {
      required : requiredIf(function () {
        return this.metaImageSrc == null;
      }),
      fileSizeValidation
    },
  },
  watch: {
    meta_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.metaImageSrc = value;
            })
            .catch(() => {
              this.metaImageSrc = null;
            });
        } else {
          this.metaImageSrc = null;
        }
      }
    },
  },
  methods: {
    removeMetaImage() {
      this.meta_image = null;
      this.meta_image_url = "";
      this.metaImageName = "";
      this.metaImageSrc = null;
    },
    onSelectMeta(evt) {
      if(evt.target.files.length > 0){
        this.metaImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    async uploadMetaImage() {
      if (this.metaImageName == "") return;

      const formData = new FormData();
      formData.append("file", this.meta_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.meta_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    setTab(tab) {
      this.activeTab = tab;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    async submit() {
      await Promise.all([
        [this.enTitleEditorInstance, 'en_title'],
        [this.cnTitleEditorInstance, 'cn_title'],
        [this.localTitleEditorInstance, 'local_title'],
        [this.enBodyEditorInstance, 'en_body'],
        [this.cnBodyEditorInstance, 'cn_body'],
        [this.localBodyEditorInstance, 'local_body']
      ].map(([editor, field]) => this.syncEditor(editor, field)))

      await this.$nextTick()

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    async syncEditor(editor, field) {
      if (!editor) return

      if (editor.mode === 'source') {
        await new Promise(resolve => {
          editor.once('mode', resolve)
          editor.setMode('wysiwyg')
        })
      }

      this[field] = editor.getData()
    },
    proceed() {
      let url = config.cmsSEOPageEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        page_id: this.page_id,
        en_item_name: this.en_item_name,
        en_body: this.en_body,
        cn_item_name: this.cn_item_name,
        cn_body: this.cn_body,
        local_item_name: this.local_item_name,
        local_body: this.local_body,
        meta_title: this.meta_title,
        meta_desc: this.meta_desc,
        meta_keywords: this.meta_keywords,
        meta_url: this.meta_url,
        meta_canonical: this.meta_canonical,
        meta_author: this.meta_author,
        meta_publisher: this.meta_publisher,
        meta_lang: this.meta_lang,
        schema: this.schema
        // meta_image_url: this.imagePath + this.meta_image_url
      };

      if (!/^https?:\/\//i.test(this.meta_image_url)) {
        json.meta_image_url = this.imagePath + this.meta_image_url
      } else {
        json.meta_image_url = this.meta_image_url
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editSEOPage.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_seo_page", this.feedback.status);
                this.$refs.editSEOPage.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async confirmSubmit() {
      const p1 = this.uploadMetaImage();
      const someResult = await p1;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.activeTab = 'en';
    },
    shown: function() {
      this.enBodyEditorInstance = null;
      this.cnBodyEditorInstance = null;
      this.localBodyEditorInstance = null;
      this.page_id = this.item.id;
      this.page_name = this.item.page_name;
      this.en_item_name = this.item.en_item_name;
      this.en_body = this.item.en_body;
      this.cn_item_name = this.item.cn_item_name;
      this.cn_body = this.item.cn_body;

      this.local_item_name = this.item.local_item_name;
      this.local_body = this.item.local_body;

      this.meta_title = this.item.meta_title;
      this.meta_desc = this.item.meta_desc;
      this.meta_keywords = this.item.meta_keywords;
      this.meta_url = this.item.meta_url;
      this.meta_canonical = this.item.meta_canonical;
      this.meta_author = this.item.meta_author;
      this.meta_publisher = this.item.meta_publisher;
      this.meta_lang = this.item.meta_lang;
      this.meta_image_url = this.item.meta_image_url != null ? this.item.meta_image_url : null;
      this.metaImageSrc = this.item.meta_image_url != null ? this.item.meta_image_url : null;
      this.metaImageName = "";
      this.schema = this.item.schema;
      this.$v.$reset();
      $("#editSEOPage").find('.modal-content').first().removeAttr('tabindex');
    },
    // Enhanced CKEditor security setup method
    setupEditorSecurity(editor) {
      // Block paste files/base64 images
      editor.on('paste', function (e) {
        if (e.data && e.data.dataTransfer && typeof e.data.dataTransfer.getFiles === 'function') {
          const files = e.data.dataTransfer.getFiles();
          if (files && files.length > 0) {
            e.cancel();
            return;
          }
        }
        if (e.data && e.data.dataValue && e.data.dataValue.indexOf('data:image') !== -1) {
          e.cancel();
        }
      });

      // Block drag & drop files/images
      editor.on('contentDom', function () {
        editor.document.on('drop', function (e) {
          const dataTransfer = e.data.$.dataTransfer;
          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            e.data.preventDefault(true);
          }
        });
      });

      // Additional security measures
      editor.on('beforeCommandExec', function (evt) {
        const command = evt.data.name;
        // Block potentially dangerous commands
        if (command === 'execCommand' || command === 'insertHtml') {
          // Add additional validation if needed
        }
      });

      if (editor._dialogSecurityHooked) return;
      editor._dialogSecurityHooked = true;

      // Hook dialog definition for upload button override
      editor.on('dialogDefinition', function (ev) {
        const dialogName = ev.data.name;
        const dialogDefinition = ev.data.definition;

        if (dialogName === 'image') {
          const uploadTab = dialogDefinition.getContents('Upload');
          const uploadButton = uploadTab.get('uploadButton');

          // Ensure upload input exists
          if (!uploadTab.get('upload')) {
            uploadTab.add({
              type: 'file',
              id: 'upload',
              label: 'Send it to the Server',
              size: 38,
            });
          }

          uploadButton['for'] = ['Upload', 'upload'];

          // Override upload button click
          uploadButton.onClick = function (evt) {
            const dialog = evt.sender.getDialog();
            const fileInput = dialog.getContentElement('Upload', 'upload').getInputElement().$;
            const file = fileInput.files[0];

            var invalidImage = this.$helpers.checkImgCkEditor(file);
            if (invalidImage)
              return;

            const formData = new FormData();
            formData.append('upload', file);

            fetch(editor.config.filebrowserUploadUrl, {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.uploaded === 1) {
                  dialog.getContentElement('info', 'txtUrl').setValue(data.url);
                  dialog.hide();
                } else {
                  const msg = (data.error && data.error.message) || 'Upload failed.';
                  alert(msg);
                  fileInput.value = '';
                }
              })
              .catch((err) => {
                alert('Upload error: ' + err.message);
                fileInput.value = '';
              });
          };
        }
      });

      // Attach validation after the dialog actually appears
      var vm = this;
      editor.on('dialogShow', function (evt) {
        const dialog = evt.data;
        if (dialog.getName() !== 'image') return;

        // Wait for DOM to render
        setTimeout(() => {
          const uploadElement = dialog.getContentElement('Upload', 'upload');
          if (!uploadElement) return;

          const input = uploadElement.getInputElement().$;

          // remove old listener (avoid duplicates)
          input.removeEventListener('change', input._vueFileChangeHandler || (() => {}));

          // attach new listener
          input._vueFileChangeHandler = function () {
            const file = input.files[0];
            if (!file) return;

            var invalidImage = vm.$helpers.checkImgCkEditor(file);
            if (invalidImage) {
              input.value = '';
              return;
            }
          };

          input.addEventListener('change', input._vueFileChangeHandler);
        }, 100);
      });
    }
  }
};
</script>
